module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"appName":"TRAC19","info":"Informazioni","contacts":"Contatti","privacy":"Informativa Privacy","questions":"Domande frequenti"}}')
  delete Component.options._Ctor
}
